export const START_EXPOSURE_I18N_KEYS = [
  'game.room.paidExposureWarningTitle',
  'game.room.paidExposureWarning',
  'game.room.hostPaidExposureWarningTitle',
  'game.room.hostPaidExposureWarning',
  'game.room.paidExposureConfirm',
  'game.room.paidExposureCancel',
] as const

export interface HostExposure {
  willStartPaid: boolean
  humanCount: number
  needsStartConfirmation: boolean
}

export function shouldConfirmStart(
  exposure?: HostExposure | null,
): boolean {
  return exposure?.needsStartConfirmation === true
}
